import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;

export const ButtonWrapper = styled.div`
  width: 72px;
  height: 37px;

  > button.MuiButtonBase-root {
    height: 37px;
  }
`;
